// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__hM2zx","header":"style__header__TLo6g","body":"style__body__Z3zFD","footer":"style__footer__fKu5+","disableGestures":"style__disableGestures__fDXWs"};